
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import MaskedPhoneInput from "@/components/common/MaskedPhoneNew.vue";
import EducationForm from "@/components/profile/educations/EducationFormResume.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    FormWrapper,
    MaskedPhoneInput,
    EducationForm,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Object, required: false })
  readonly educations?: Object;

  isHovered: boolean = false;
  updatedEducation: Object = this.educations;

  closeModal(): void {
    this.$emit("close");
  }

addEducation(newEdu) {
      if (this.updatedEducation) {
        this.$emit('edit-education', { oldName: this.updatedEducation, newName: newEdu });
      } else {
        this.$emit('add-education', newEdu);
      }
      this.$emit('close');
    }

    editEducation(newEdu) {
        this.$emit('edit-education', {
        oldName: this.updatedEducation,
        newName: newEdu,
      });
      this.closeModal();
    }
    
}
